import axios from 'axios';
import { AccumulatorChartDataList } from '../../interfaces/Accumulator';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { DateRangeInterface } from '../Pickers/dataRange';

export type ModelName = {
    id: number;
    name: string;
}

export type Building = {
    id: number,
    building_name: string
}


export type StatusCount = {
    TypeMessage: number,
    count: number
}


export type AccumulatorDetails = {
    id: number;
    model_name: string;
    building_id?: Building;
    device_type: string;
    online_date: string;
    soh:number,
    charge: number;
    discharge: number;
    cycles: number | null;
    part_cycles: number | null;
    created_at: string; // You can use Date if you're parsing it to a Date object
    serial_number: string;
    manufacture_date: string | null;
    comment: string | null;
    is_cooling_activity: boolean;
    is_heating_activity: boolean;
    is_default_activity: boolean;
    is_waterproof_activity: boolean;
    accum_image: string | null;
    is_configured: boolean;
    custom_name: string | null;
    exploatation_date: string | null;
    voltage: number | null;
    nominal_capacity: number | null;
    status: number;
    last_init_time: string | null;
    status_counts: StatusCount[];
    is_commissioned: boolean;
    bms_model: string;
    coordinates: {
        Latitude: string;
        Longitude: string;
    } | null;
    customer_comment: string | null;
    image : {
        image: string
    } | null;
    client_device_type: {
        device_name: string;
    }
}


export const fetchAcbDetails = async (role: string, serialNumber: string, setter : (value: AccumulatorDetails) => void) => {
    axios.get<AccumulatorDetails>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/details`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: AccumulatorDetails = response.data
            setter(data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
        console.error('Error fetching accumulator details:', error);
        // Handle the error accordingly
    });
}


export type ChartDataResponse = {
    data : AccumulatorChartDataList | null;
}


export const FetchChartData = async (role: string, serialNumber: string, setter : (value: ChartDataResponse) => void, dateRangeValues: DateRangeInterface | null) => {
    axios.post<ChartDataResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/charts`,
        {
            serial_number:serialNumber,
            start: dateRangeValues !== null ? dateRangeValues.start.slice(0, 10) : null,
            end: dateRangeValues !== null ? dateRangeValues.end.slice(0, 10) : null
        },
        { 
            headers: {
                'X-CSRFToken': getCsrftoken(),
                'Content-Type': 'application/json'
            },
            withCredentials: true 
        }
    )
    .then(response => {
            if (response.status === 200) {
                var data: any = response.data
                if (data === "") {
                    data = undefined
                }
                setter(data)
            }
        }
    )
    .catch(error => {
        console.error('Error fetching chart data details:', error);
        // Handle the error accordingly
    });
}

